<template>
  <!--密码修改-->
  <div>
    <div class="goods-head">
      <div class="slider-list" :class="[{'slider-list-xz':tabXz==0}]" @click="tabCLick(0)">
        <div class="item">密码修改</div>
      </div>
      <div class="slider-list" :class="[{'slider-list-xz':tabXz==1}]" @click="tabCLick(1)">
        <div class="item">解绑手机号</div>
      </div>
    </div>
    <div class="main-wrap">
      <div v-if="tabXz==0" class="main">
        <div class="main-tips clearfloat">
          <p class="main-tips-txt">修改密码前，您需要手机验证，您目前绑定的手机号码<span v-if="informationData.subPhone">{{ informationData.subPhone | subStringPhone }}</span></p>
          <el-button class="main-tips-btn code-btn" :disabled="phoneCode.disabled" @click="getCodeClick(informationData.phone)">{{ phoneCode.sendCodeText }} {{ phoneCode.second }}</el-button>
        </div>
        <el-form
          ref="information"
          class="information"
          :model="informationData"
          :rules="rules"
          label-position="right"
          label-width="7rem"
        >
          <el-row :gutter="24">
            <el-col :span="15" :offset="4">
              <el-form-item label="手机验证码" prop="verificationCode" required>
                <el-input v-model="informationData.verificationCode" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="15" :offset="4">
              <el-form-item label="新密码" prop="password" required>
                <el-input v-model="informationData.password" v-input-filter type="password" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="15" :offset="4">
              <el-form-item label="确认新密码" prop="confirmPassword" required>
                <el-input v-model="informationData.confirmPassword" v-input-filter type="password" />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="information-btn" @click="submitForm('information')">
            保存
          </div>
        </el-form>
      </div>
      <div v-if="tabXz==1" class="main">
        <div class="main-tips clearfloat">
          <p class="main-tips-txt">您目前绑定的手机号码<span v-if="informationData.subPhone">{{ informationData.subPhone | subStringPhone }}</span></p>
          <el-button class="main-tips-btn code-btn" :disabled="phoneUntyingCode.disabled" @click="getCodeUntying(informationData.phone)">{{ phoneUntyingCode.sendCodeText }}{{ phoneUntyingCode.second }}</el-button>
        </div>
        <el-form
          ref="phoneForm"
          class="information"
          :model="phoneData"
          :rules="rules"
          label-position="right"
          label-width="8rem"
        >
          <!--<el-row :gutter="24">-->
          <!--<el-col :span="15" :offset="4">-->
          <!--<el-form-item label="当前手机号" class="code-box" prop="oldPhone" required>-->
          <!--<el-input v-model="phoneData.oldPhone" />-->
          <!--<div class="fasong" @click="getCodeClick(phoneData.oldPhone)">获取验证码</div>-->
          <!--</el-form-item>-->
          <!--</el-col>-->
          <!--</el-row>-->
          <el-row :gutter="24">
            <el-col :span="15" :offset="4">
              <el-form-item label="当前手机验证码" prop="verificationCode" required>
                <el-input v-model="phoneData.verificationCode" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="15" :offset="4">
              <el-form-item ref="newPhone" label="新手机号码" class="code-box" prop="phone" required>
                <el-input v-model="phoneData.phone" />
                <el-button class="fasong" :disabled="phoneNewCode.disabled" @click="getNewCodeClick(phoneData.phone)">{{ phoneNewCode.sendCodeText }}{{ phoneNewCode.second }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="15" :offset="4">
              <el-form-item label="新手机验证码" prop="newVerificationCode" required>
                <el-input v-model="phoneData.newVerificationCode" />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="information-btn" @click="SubmissionForm('phoneForm')">
            提交
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import * as get from '@/api/personal/user/parss-modify/index.js' // 请求接口
import { mapGetters } from 'vuex'
import { CountDown } from '@/utils/common'
// import { checkStrong } from '@/utils/checkpassStrong.js'
import inputFilter from '@/directives/validation/index.js'
export default {
  name: 'ParssModify',
  filters: {
    subStringPhone(value) {
      return value.substr(0, 3) + '****' + value.substr(7)
    }
  },
  directives: {
    inputFilter
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.informationData.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    const phoneIndexIf = (rule, value, callback) => {
      if (value == this.informationData.subPhone) {
        callback(new Error('不可与原手机号一致'))
      } else {
        callback()
      }
    }
    return {
      // 修改密码验证码
      phoneCode: {
        sendCodeText: '发送验证码',
        disabled: false,
        timer: null,
        second: ''
      },
      // 解绑验证码
      phoneUntyingCode: {
        sendCodeText: '发送验证码',
        disabled: false,
        timer: null,
        second: ''
      },
      phoneNewCode: {
        sendCodeText: '发送验证码',
        disabled: false,
        timer: null,
        second: ''
      },
      // 修改密码数据
      informationData: {
        subPhone: '', // 手机号筛选
        phone: '', // 手机号
        verificationCode: '', // 验证码
        password: '', // 密码
        confirmPassword: '' // 确认密码
      },
      // 解绑手机号数据
      phoneData: {
        subPhone: '', // 手机号筛选
        oldPhone: '', // 当前手机号
        verificationCode: '', // 当前验证码
        phone: '', // 新手机号码
        newVerificationCode: '' // 新手机号码验证码
      },
      // 正则
      rules: {
        verificationCode: [{ required: true, message: '必填' }],
        password: [
          { min: 6, max: 20, message: '长度6-20位', trigger: 'blur' },
          { validator: this.$validate('password') },
          { required: true, message: '必填' }
        ],
        currentCode: [{ required: true, message: '必填' }],
        newCode: [{ required: true, message: '必填' }],
        newVerificationCode: [{ required: true, message: '必填' }], // 新手机号验证码
        confirmPassword: [
          { min: 6, max: 20, message: '长度6-20位', trigger: 'blur' },
          { validator: this.$validate('password') },
          { validator: validatePass, trigger: 'blur' },
          { required: true, message: '必填' }
        ],
        phone: [
          { required: true, message: '请输入手机号'},
          { validator: this.$validate('phone') },
          { validator: phoneIndexIf, trigger: 'blur' }
        ],
        oldPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: this.$validate('phone') }
        ]
      },
      //  tab状态
      tabXz: 0
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.getPhone()
  },
  methods: {
    // 修改密码获取验证码
    getCodeClick(name) {
      this.phoneTimer()
      // 执行获取验证码
      this.getPhoneCode(name)
    },
    // 解绑获取验证码
    getCodeUntying(name) {
      this.phoneUntyingTimer()
      // 执行获取验证码
      this.getPhoneCode(name)
    },
    // 解绑获取新手机号验证码
    getNewCodeClick(name) {
      // 执行获取验证码
      this.$refs.phoneForm.validateField('phone', (phoneVerify) => {
        if (!phoneVerify) {
          this.phoneNewTimer()
          this.getPhoneCode(name)
        }
      })
    },
    // 修改密码设置验证码定时器
    phoneTimer() {
      const phoneCode = this.phoneCode
      phoneCode.disabled = true
      // 倒计时时间
      phoneCode.sendCodeText = CountDown
      phoneCode.second = 's'
      phoneCode.timer = setInterval(() => {
        phoneCode.sendCodeText--
        if (phoneCode.sendCodeText <= 1) {
          phoneCode.sendCodeText = '重新获取'
          phoneCode.second = ''
          // 关闭并清空定时器
          clearInterval(phoneCode.timer)
          phoneCode.timer = null
          phoneCode.disabled = false
        }
      }, 1000)
    },
    // 解绑设置验证码定时器
    phoneUntyingTimer() {
      const phoneCode = this.phoneUntyingCode
      phoneCode.disabled = true
      // 倒计时时间
      phoneCode.sendCodeText = CountDown
      phoneCode.second = 's'
      phoneCode.timer = setInterval(() => {
        phoneCode.sendCodeText--
        if (phoneCode.sendCodeText <= 1) {
          phoneCode.sendCodeText = '重新获取'
          phoneCode.second = ''
          // 关闭并清空定时器
          clearInterval(phoneCode.timer)
          phoneCode.timer = null
          phoneCode.disabled = false
        }
      }, 1000)
    },
    // 解绑获取新手机验证码定时器
    phoneNewTimer() {
      const phoneCode = this.phoneNewCode
      phoneCode.disabled = true
      // 倒计时时间
      phoneCode.sendCodeText = CountDown
      phoneCode.second = 's'
      phoneCode.timer = setInterval(() => {
        phoneCode.sendCodeText--
        if (phoneCode.sendCodeText <= 1) {
          phoneCode.sendCodeText = '重新获取'
          phoneCode.second = ''
          // 关闭并清空定时器
          clearInterval(phoneCode.timer)
          phoneCode.timer = null
          phoneCode.disabled = false
        }
      }, 1000)
    },
    // 获取验证码
    getPhoneCode(code) {
      console.log(code)
      get.getCode({
        phone: code
      }).then(res => {
        console.log(res)
        this.$message({
          message: '发送成功',
          type: 'success'
        })
      }).catch(error => {
        console.log(error)
      })
    },
    // 确定提交表单
    submitForm(formName) {
      // 正则匹配
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            userId: this.userInfo.userId,
            phone: this.informationData.phone,
            password: this.informationData.password,
            verificationCode: this.informationData['verificationCode']
            // passwordLevel: checkStrong(this.informationData.password)
          }
          get.changePassword(
            data
          ).then(res => {
            this.getPhone()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.logout()
          }).catch(error => {
            console.log(error)
          })
        } else {
          return false
        }
      })
    },
    // 提交修改手机号表单
    SubmissionForm(formName) {
      // 正则匹配
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            userId: this.userInfo.userId,
            oldPhone: this.informationData.subPhone,
            verificationCode: this.phoneData.verificationCode,
            phone: this.phoneData.phone,
            newVerificationCode: this.phoneData.newVerificationCode
          }
          get.untyingPhone(data).then(res => {
            this.getPhone()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
          }).catch(error => {
            console.log(error)
          })
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    tabCLick(id) {
      this.tabXz = id
    },
    //  获取当前绑定手机号
    getPhone() {
      get.getInformation({
        userId: this.userInfo.userId
      }).then(res => {
        // this.phoneData.phone = res.result.phone
        // this.phoneData.subPhone = res.result.phone

        this.informationData.phone = res.result.phone
        this.informationData.subPhone = res.result.phone
      }).catch(error => {
        console.log(error)
      })
    },
    // 退出登录
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>
<style scoped lang='scss'>
  $main-color: #be2316;
  .goods-head {
    padding: 12px 12px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    width: 928px;
    height: 50px;

    .slider-list {
      float: left;
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 0.5s;
        color: black;
        cursor: pointer;
      }
      &.slider-list-xz{
        .item {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          font-weight: bold;
          color: $main-color;
        }
      }
    }
  }
  .main{
    min-height: 550px;
    border-color: #f1f1f1;
    background-color: #ffffff;
    padding: 40px 20px 50px 20px;
    .main-tips{
      width: auto;
      height: 32px;
      display: inline-block;
      margin-left: 188px;
      .main-tips-txt{
        float: left;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #BE2316;
      }
      .main-tips-btn{
        /*width: 100px;*/
        height: 30px;
        line-height: 0px;
        text-align: center;
        font-size: 14px;
        border: 1px solid #BE2316;
        color: #BE2316;
        border-radius:4px;
        margin-left: 15px;
        cursor: pointer;
      }
    }
    .information{
      padding-top: 20px;
      .information-btn{
        width: 136px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #BE2316;
        color: #fff;
        cursor: pointer;
        margin: 0 auto;
        margin-top: 30px;
        border-radius:4px;
      }
      .fasong{
        min-width: 100px;
        height: 40px;
        line-height: 0px;
        text-align: center;
        float: right;
        background: #BE2316;
        border-radius: 4px;
        color: #fff;
        cursor: pointer;
      }
      .code-box{
        /deep/.el-form-item__content{
          .el-input{
            width: calc(100% - 120px)
          }
        }
      }
    }
  }

</style>
